import React, {FunctionComponent, useEffect, useState} from "react"
import {MurphyDroneEventDto} from "@murphy-frontend/common/interfaces/IDroneEventsApi"
import {TimeZoneType, getConvertedDateDayjs} from "@murphy-frontend/common/services/TimeService"
import {ColumnHeaderCell, ColumnRowCell} from "@murphy-frontend/web-core/components/Table/Models"
import Table from "@murphy-frontend/web-core/components/Table"
import FilterTag from "@murphy-frontend/web-core/components/FilterTag"
import {useUserPreferences} from "../../../common/contexts/UserPreferencesContext"

interface StartedEventFlowsTableProps {
	startedEventFlows: MurphyDroneEventDto[]
	timeZone: TimeZoneType
}

const StartedEventFlowsTable: FunctionComponent<StartedEventFlowsTableProps> = ({startedEventFlows, timeZone}) => {
	const [tableData, setTableData] = useState<ColumnRowCell[][]>([])
	const {translations} = useUserPreferences()

	const StartedEventFlowColumns: ColumnHeaderCell[] = [
		{
			columnKey: "status",
			displayName: translations["class-lang-modal-status"],
			isSortable: true,
			size: "column-large"
		},
		{
			columnKey: "incident",
			displayName: translations.eventflowsmodulename,
			isSortable: true,
			size: "column-large"
		},
		{
			columnKey: "lastUpdated",
			displayName: translations.lastUpdated,
			isSortable: true,
			size: "column-medium"
		},
		{
			columnKey: "dateCreated",
			displayName: translations.created,
			isSortable: true,
			size: "column-medium"
		},
		{
			columnKey: "creator",
			displayName: translations.creator,
			isSortable: true,
			size: "column-medium"
		}
	]

	useEffect(() => {
		const rows = startedEventFlows.map((ev, idx) => {
			return [
				{
					id: ev.Id,
					rowId: idx,
					displayValue: <FilterTag status={ev.Open} filterName={ev.Open ? "Active" : "Closed"} />,
					value: ev.Open ? "Active" : "Closed",
					customClass: "text-center",
					columnKey: "status",
					url: `/startedeventflows/${ev.Id}`
				},
				{
					id: ev.Id,
					rowId: idx,
					displayValue: ev.Name,
					value: ev.Name,
					customClass: "text-center",
					columnKey: "incident",
					url: `/startedeventflows/${ev.Id}`
				},
				{
					id: ev.Id,
					rowId: idx,
					displayValue: getConvertedDateDayjs(ev.LastUpdatedUTC, timeZone).format("DD MMM YYYY, HH:mm:ss"),
					value: ev.LastUpdatedUTC,
					customClass: "text-center",
					columnKey: "lastUpdated",
					url: `/startedeventflows/${ev.Id}`
				},
				{
					id: ev.Id,
					rowId: idx,
					displayValue: getConvertedDateDayjs(ev.CreatedUTC, timeZone).format("DD MMM YYYY, HH:mm:ss"),
					value: ev.CreatedUTC,
					customClass: "text-center",
					columnKey: "dateCreated",
					url: `/startedeventflows/${ev.Id}`
				},
				{
					id: ev.Id,
					rowId: idx,
					displayValue: ev.CreatedByUserEmail,
					value: ev.CreatedByUserEmail,
					customClass: "text-center",
					columnKey: "creator",
					url: `/startedeventflows/${ev.Id}`
				}
			]
		})

		setTableData(rows)
	}, [startedEventFlows])

	return (
		<section className='table-container-general'>
			<Table rows={tableData} columns={StartedEventFlowColumns} key={"eventFlows"} />
		</section>
	)
}

export default StartedEventFlowsTable
